// reducers/couponReducers.js
export const couponListReducer = (state = { loading: false, coupons: [] }, action) => {
  switch (action.type) {
    case "COUPON_LIST_REQUEST":
      return { ...state, loading: true, error: null };
    case "COUPON_LIST_SUCCESS":
      return { ...state, loading: false, coupons: action.payload, error: null };
    case "COUPON_LIST_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "COUPON_DELETE_SUCCESS":
      return { ...state, coupons: state.coupons.filter(c => c._id !== action.meta.id) };
    case "COUPON_UPSERT_SUCCESS": {
      const c = action.payload;
      const idx = state.coupons.findIndex(x => x._id === c._id);
      const next = [...state.coupons];
      if (idx >= 0) next[idx] = c; else next.unshift(c);
      return { ...state, coupons: next };
    }
    default:
      return state;
  }
};
